<template>
    <section class="position-relative d-flex align-items-center py-5" id="cookies">
    <div class="container-xl py-5">
        <h4 class="text-center text-white mb-4">Wybierz ciastko z wróżbą</h4>
        <div class="row row-cookie row-cols-1 row-cols-md-4"
            v-if="parent.data"
        >
            <div class="col col-cookie d-flex justify-content-center align-items-center" style="height:250px" v-for="(item, key) in result" :key="key"
            :class="key ==  5 ? 'mx-auto' : ''"
            >
            <div class="position-relative cookie-holder"
                ref="cookiePos"
            >
            <div v-if="spinner == key" class="d-flex justify-content-center align-items-center position-absolute spinner-cookie">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
                <transition
                @before-enter="beforeEnter"
                @before-leave="beforeLeave"
                @enter="enter"
                @leave="leave"
                :css="false">
                    <img v-if="!open || active != key" class="mw-100 mh-100 cookie-anim btn"
                    key="close"
                    :class="'pulse-' + key"
                    @click="randomCookie(key)"
                    :src="'/img/cookie/cookie'+(key+1)+'.png'">

                    <img class="openCookie btn position-absolute"
                    :src="random.url"
                    ref="openCookie"
                    key="open"
                    style="max-width: 450px;"
                    @click="open = !open; active = null; openModal = false; random = null;"
                    v-if="active == key && open"
                    >
                </transition>
            </div>
            </div>
        </div>

        <transition
            @before-enter="beforeEnterModal"
            @enter="enterModal"
            @leave="leaveModal"
            :css="false"
        >
            <div class="modal cookie"
                v-if="openModal && random"
                ref="modalCookie" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable mx-sm-auto mx-0">
                    <div class="modal-content">
                    <div class="modal-body px-sm-2 px-1" style="overflow-x: hidden;">
                        <button type="button" class="close big text-white"
                            @click="open = !open; active = null; openModal = false; random = null;"
                        data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                        <img :src="random.url" class="mw-100 mh-100 m-auto d-block img-cookie-home">
                        <div v-if="random.show_content" class="content" v-html="random.content"></div>
                        <div class="d-flex justify-content-end mt-3">
                            <ShareNetwork
                                network="facebook"
                                :url="social.url"
                                :title="social.title"
                                class="btn btn-sm btn-primary"
                            >
                                <span><iconShare />Udostępnij na Facebooku</span>
                            </ShareNetwork>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>

</section>
</template>

<script>
    import iconShare from '../icon/share';

    export default {
        data(){
            return {
                position: [
                    {top: -30, left: 80},
                    {top: 90, left: 20},
                    {top: 0, right: 35},
                    {top: 0, right: 80},
                    {bottom: 30, left: 80},
                    {bottom: -50, left: 45},
                    {bottom: 0, right: 75},
                ],
                result: 7,
                open: false,
                active: null,
                openModal: false,
                hide: null,
                parent: this.$parent._data,
                random: null,
                spinner: null,

                social:
                {
                    url: null,
                    title: null,
                }
            }
        },
        components: {
            iconShare
        },
        watch: {
            'parent.data'(){
                Vue.nextTick(() => {
                    this.sizeWidth($(window).width())
                });
            }
        },
        mounted() {
            let _this = this;
            $(window).on('resize', function(){
                _this.sizeWidth($(this).width())
            })

            this.$nextTick(() => {
                let tick = this;
                $(tick.$refs.cookiePos).each(function(i){
                    tick.changeCookie()
                })
            });
        },
        methods: {
            beforeEnterModal(el){
                el.style.opacity = 0;
                el.style.display = "block";

                $(el).find('.modal-content').css('top', -100);
            },
            enterModal(el, done){
                let _this = this;
                $('html').css('overflow', 'hidden');
                $(el).animate({
                    opacity: 1,
                    top: 0,
                },1000)
                $(el).find('.modal-content').animate({
                    top: 0,
                },1000, function(){
                    done();
                })
            },
            beforeEnter(el) {
                el.style.opacity = 0;
            },
            leaveModal(el, done){
                let _this = this;
                $('html').css('overflow', '');

                $(el).animate({
                    opacity: 0,
                },1000)
                $(el).find('.modal-content').animate({
                    top: -100,
                },1000, function(){
                    done();
                })
            },
            beforeLeave(el) {
                el.style.opacity = 1;
            },
            enter(el, done) {
                let _this = this;
                $(el).animate({
                    opacity: 1,
                },1000, function(){
                    done();

                    if(_this.$refs.openCookie.length > 0)
                    {
                        _this.openModal = true;
                    }
                })
            },
            leave(el, done) {
                let _this = this;

                $(el).animate({
                    opacity: 0,
                },1000, function(){
                    done();
                })
            },
            sizeWidth(width){
                if(width < 767.98)
                {
                    this.result = 3;
                    this.position = [];
                    this.changeCookie();
                }
                else
                {
                    this.result = 7;

                    this.position = [
                        {top: -30, left: 80},
                        {top: 90, left: 20},
                        {top: 0, right: 35},
                        {top: 0, right: 80},
                        {bottom: 30, left: 80},
                        {bottom: -50, left: 45},
                        {bottom: 0, right: 75},
                    ];
                    this.changeCookie();
                }
            },
            randomCookie(key){
                this.spinner = key;
                axios
                .get('/random/cookie').then(response => {
                    this.random = response.data;
                    this.social.url = window.location.origin + '/share/cookie/details/' + response.data.id;
                    this.social.title = response.data.title;

                    this.open = true;
                    this.hide = key;
                    this.active = key;

                    this.spinner = null;
                });
            },
            changeCookie()
            {
                let _this = this;

                if(this.position.length > 3)
                {
                    $(this.$refs.cookiePos).each(function(i){
                        $(this).css({
                            left: _this.position[i].left ? _this.position[i].left : '',
                            top: _this.position[i].top ? _this.position[i].top : '',
                            right: _this.position[i].right ? _this.position[i].right : '',
                            bottom: _this.position[i].bottom ? _this.position[i].bottom : '',
                        })
                    })
                }
                else
                {
                    $(this.$refs.cookiePos).each(function(i){
                        $(this).css({
                            left: '',
                            top: '',
                            right: '',
                            bottom: '',
                        })
                    })
                }
            }
        }
    }
</script>
